export default "__VITE_ASSET__bb3af0c8__"